import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/button/ActionButton';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';
import { MailIcon } from 'assets/materialIcons/materialIcons';

const SendVoucher = ({ style, translate, toggleVoucherModal }) => {

    return (
        <Button
            icon={ <MailIcon color={ theme.palette.doveGray } /> }
            onClick={ toggleVoucherModal }
            style={ style }
            title={ translate('resources.orders.voucher.send.title') }
        />
    );
};

SendVoucher.defaultProps = {
    style: {},
};

SendVoucher.propTypes = {
    style: PropTypes.object,
    translate: PropTypes.func.isRequired,
    toggleVoucherModal: PropTypes.func.isRequired,
};

export default translate(SendVoucher);



// WEBPACK FOOTER //
// ./src/components/button/Voucher/SendVoucher.js